import React, { useState, useRef } from 'react';
import type { MessageTooltipContentProps } from '@archipro-design/aria';
import { MessageTooltip, useStyles } from '@archipro-design/aria';
import * as S from './FloatingAction.style';
import { useScroll } from 'ahooks';

interface FloatingActionProps {
    onClick: () => void;
    icon: JSX.Element;
    tooltipText: string;
    tooltipImage?: JSX.Element;
}

export const FloatingAction = ({
    onClick,
    icon,
    tooltipText,
    tooltipImage,
}: FloatingActionProps) => {
    const { css } = useStyles();
    const triggerRef = useRef<HTMLDivElement>(null);

    // by requirement, we're showing tooltip by default and hiding it as soon as the user scrolls
    const [showTooltips, setShowTooltips] = useState(true);
    useScroll(null, ({ top }) => {
        if (top > 0 && showTooltips) {
            setShowTooltips(false);
        }
        return true;
    });

    const tooltip: MessageTooltipContentProps = tooltipImage
        ? {
              className: css(S.FloatingTooltip),
              icon: <div>{tooltipImage}</div>,
              iconPosition: 'before',
              children: tooltipText,
              padding: 8,
              color: 'white',
          }
        : {
              className: css(S.FloatingTooltip),
              children: tooltipText,
              padding: 8,
              color: 'white',
          };

    return (
        <MessageTooltip
            open={showTooltips}
            trigger={
                <div
                    className={css(S.FloatingIcon)}
                    ref={triggerRef}
                    onMouseEnter={() => setShowTooltips(true)}
                    onMouseLeave={() => setShowTooltips(false)}
                    onMouseDown={() => setShowTooltips(false)}
                    onClick={onClick}
                >
                    {icon}
                </div>
            }
            content={tooltip}
            position="after"
            offset={[0, 16]}
        />
    );
};
